"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgUserSvg = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ fill: "none", height: 24, width: 20, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ stroke: "#6f6e89", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: 9.674, cy: 6.468, opacity: 0.4, r: 5.468 }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M1 19.543a2.535 2.535 0 0 1 .251-1.11c.524-1.048 2.001-1.604 3.227-1.855.884-.189 1.78-.315 2.682-.377a28.681 28.681 0 0 1 5.018 0c.901.063 1.797.189 2.681.377 1.226.251 2.703.754 3.227 1.854a2.598 2.598 0 0 1 0 2.231c-.524 1.1-2 1.603-3.226 1.844-.883.197-1.78.326-2.682.388a29.556 29.556 0 0 1-4.086.063c-.314 0-.618 0-.932-.063-.9-.061-1.792-.19-2.672-.388-1.236-.24-2.702-.744-3.237-1.844A2.608 2.608 0 0 1 1 19.543z" })] })) }))); };
exports.default = SvgUserSvg;
